<template>
  <b-field
    :label="label + ' *'"
    :type="{ 'is-danger': errors.has(randName) }"
    :message="errors.first(randName)"
  >
    <b-autocomplete
      v-model="buffer"
      @blur="$emit('blur')"
      @change.native="$emit('change')"
      :data="geonamesCities"
      :placeholder="label + ' *'"
      :icon="icon"
      :readonly="readonly"
      field="name"
      :name="randName"
      clearable
      expanded
      v-validate="{
        required: true,
        geonameCity: cityCountry
      }"
      @keyup.native="getGenonamesVilles"
      @select="emitSelect"
    >
      <template slot-scope="props">
        <div class="media">
          <div class="media-left">
            <flag :iso="props.option.countryCode" />
          </div>
          <div class="media-content">
            <strong>{{ props.option.name }}</strong>
            <br />
            <small>
              <em v-if="props.option.adminName1">
                {{ props.option.adminName1 }},
              </em>
              {{ props.option.countryName }}
            </small>
          </div>
        </div>
      </template>
      <template slot="empty">{{ $t('compGeonamesInput.error-2') }}</template>
    </b-autocomplete>
    <p v-if="withFlag" class="control">
      <span
        expanded
        class="button is-static"
        v-bind:class="{ 'is-danger': errors.has(randName) }"
      >
        <flag v-if="city.countryCode" :iso="city.countryCode" />
        <i v-else class="fa fa-flag" aria-hidden="true"></i>
      </span>
    </p>
  </b-field>
</template>

<script>
import { useCoreStore } from '@/stores/core.js'
import { searchGEONames } from '@/utils/geonames'

export default {
  name: 'GeonamesInput',
  inject: ['$validator'],
  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: 'map-marker'
    },
    countryCode: {
      type: String,
      default: null
    },
    allowedCountries: {
      type: Array,
      default: function () {
        return []
      }
    },
    withFlag: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  setup () {
    const coreStore = useCoreStore()
    return { coreStore }
  },
  data () {
    return {
      city: {
        countryCode: this.countryCode
      },
      geonamesCities: [],
      buffer: this.value
    }
  },
  computed: {
    randName: function () {
      return 'geonames' + Math.floor(Math.random() * 1000000)
    },
    cityCountry: function () {
      let country = ''
      if (this.city.countryCode) {
        country = this.city.countryCode
      }
      return country
    }
  },
  watch: {
    value: {
      handler () {
        if (!this.readonly) {
          this.buffer = this.value
          if (this.value === null) {
            this.city = {
              countryCode: null
            }
          } else {
            this.city = {
              countryCode: this.countryCode
            }
          }
        }
      }
    }
  },
  methods: {
    getGenonamesVilles () {
      if (!this.readonly) {
        this.geonamesCities = []
        this.city = {
          countryCode: null
        }
        searchGEONames(
          this.coreStore.setting('global', 'GEONAMES_USERNAME').value,
          this.buffer,
          this.$i18n.locale,
          this.allowedCountries
        )
          .then((results) => {
            results.data.geonames.forEach((item) => {
              if (
                this.geonamesCities
                  .filter((obj) => obj.name === item.name)
                  .filter((obj) => obj.countryName === item.countryName)
                  .length === 0
              ) {
                this.geonamesCities.push(item)
              }
            })
          })
          .catch((error) => {
            throw error
          })
      }
    },
    emitSelect: function (option) {
      if (option) {
        this.buffer = option.name
        this.$emit('input', this.buffer)
        this.$emit('select', option)
        this.city = option
      }
    }
  },
  created () {
    let self = this
    this.$validator.extend('geonameCity', {
      getMessage: (field) => self.$t('compGeonamesInput.error-1'),
      validate: (value, args) => {
        let country = ''
        if (args[0]) {
          country = args[0]
        }
        return searchGEONames(
          this.coreStore.setting('global', 'GEONAMES_USERNAME').value,
          value,
          this.$i18n.locale,
          country,
          1,
          1
        )
          .then((results) => {
            let isValid = false
            if (results.data.geonames.length > 0) {
              isValid =
                results.data.geonames[0].name.toLowerCase() ===
                  value.toLowerCase() ||
                results.data.geonames[0].countryCode.toLowerCase() ===
                  country.toLowerCase()
            }
            return {
              valid: isValid
            }
          })
          .catch((error) => {
            throw error
          })
      }
    })
  }
}
</script>

<style scoped>
.button.is-static.is-danger {
  background-color: #f14668;
  border-color: #f14668;
  color: #fff;
  -webkit-box-shadow: none;
  box-shadow: none;
  pointer-events: none;
}
</style>
